/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_Timecodes_TextInputs */



/**
* | output |
* | --- |
* | "This will clear the timecodes of the selected Events." |
*
* @param {Shortcut_Keys_Clear_Timecodes_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_timecodes_text = /** @type {((inputs?: Shortcut_Keys_Clear_Timecodes_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_Timecodes_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ceci effacera les timecodes des evenements selectionnes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dadurch werden die Zeitcodes der ausgewählten Ereignisse gelöscht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("In questo modo verranno cancellati i codici temporali degli eventi selezionati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это очистит временные метки выбранных событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto borrará los códigos de tiempo de los eventos seleccionados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这将清除所选事件的时间码。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("これにより、選択したイベントのタイムコードがクリアされます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इससे चयनित इवेंट्स के टाइमकोड हट जाएंगे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Isso irá limpar os códigos de tempo dos eventos selecionados.")
	return /** @type {LocalizedString} */ ("This will clear the timecodes of the selected Events.")
});